import { render, staticRenderFns } from "./TicketDetails.vue?vue&type=template&id=74505d2e"
import script from "./TicketDetails.vue?vue&type=script&lang=js"
export * from "./TicketDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports